import CardContent from '@mui/material/CardContent';
import React, {memo} from 'react';

const MUICardContent = (props: any): any => {
    const {children, className} = props;
    return <CardContent className={className}>{children}</CardContent>;
};

export default memo(MUICardContent);
